import Vocabulary from '@/api/QVocabularyItem'

const getDefaultState = () => {
  return {
    currentVocabulary: {},
    vocabularies: [],
  }
}

// initial state
const state = getDefaultState()

const getters = {}

const actions = {
  // async functions trow errors to view
  async ADD_VOCABULARY({ dispatch, rootState }, vocabulary) {
    await Vocabulary.post(rootState.sitePath, vocabulary)
    dispatch('GET_VOCABULARIES')
  },

  async DELETE_VOCABULARY({ dispatch, rootState }, vocabulary) {
    await Vocabulary.delete(rootState.sitePath, vocabulary.id)
    dispatch('GET_VOCABULARIES')
  },

  async UPDATE_VOCABULARY({ dispatch, rootState }, vocabulary) {
    await Vocabulary.put(rootState.sitePath, vocabulary.id, vocabulary)
    dispatch('GET_VOCABULARIES')
  },

  async COPY_FROM_PARENT({ dispatch, rootState }) {
    await Vocabulary.copyFromParent(rootState.sitePath)
    dispatch('GET_VOCABULARIES')
  },

  async GET_VOCABULARY({ commit, rootState }, id) {
    const response = await Vocabulary.put(rootState.sitePath, id)
    commit('SET_CURRENT_VOCABULARY', response.data)
  },

  async GET_VOCABULARIES({ commit, rootState }) {
    try {
      const response = await Vocabulary.getQVocabularyItems(rootState.sitePath)
      commit('SET_VOCABULARIES', response)
    } catch (error) {
      commit(
        'SHOW_ALERT',
        `Error ${error.response.status} getting list of vocabularies`,
        { root: true },
      )
    }
  },
}

const mutations = {
  SET_CURRENT_VOCABULARY(state, vocabulary) {
    state.currentVocabulary = vocabulary
  },

  SET_VOCABULARIES(state, vocabularies) {
    var tmpvocabularies = []
    flatten(tmpvocabularies, vocabularies, 0)
    state.vocabularies = tmpvocabularies
  },
}

/* Calls itself to flatten the vocabularies tree */
function flatten(state, vocabularies, level) {
  vocabularies.map(vocabulary => {
    vocabulary.indent = level
    state.push(vocabulary)
    if (vocabulary.items && vocabulary.items.length) flatten(state, vocabulary.items, level + 1)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
